import { DefaultPage } from './';

export default {
  path: 'logger/:version/v',
  name: 'Logger',
  childRoutes: [
    { path: ':projectId', name: 'Default page', component: DefaultPage, isPrivate: true },
  ],
};
